<div [class.isLoading]="isLoading()">
<div [ngClass]="'step ' + ((isActiveRequest())  ? 'active' : 'inactive')">
  <div
    [ngClass]="'status-text ' + ((isActiveRequest())  ? 'active' : 'inactive')"
  >
    {{
      (isActiveRequest()) 
        ? res(`Ubt-MeasureDetail-Approval-Request-${format()}`)
        : res(
            "Ubt-MeasureDetail-Approval-Request-No-Active-Process"
          )
    }}
  </div>
  @if (isActiveRequest() ) {
    <span class="status-date">{{
      steps[0].date | date: "dd.MM.yyyy, HH:mm"
    }}</span>
  }
</div>
@if (!isTimeline()) {
  <span
    *appCheckPermission="permissions.changeHardenessDegree"
    class="bold-text"
  >
    {{
      res(
        "Ubt-MeasureDetail-Approval-Request-Modify-Maturity-Level-Directly"
      )
    }}
  </span>
  <span
    *appCheckPermission="[
      permissions.approveRequestStep1,
      permissions.approveRequestStep2,
    ]"
    class="bold-text"
  >
    {{
      res("Ubt-MeasureDetail-Approval-Request-Action-Required") +
        " - " +
        res(
          "Ubt-MeasureDetail-Approval-Request-Target-Maturity-Level"
        ) +
        ": " +
        nextMaturityLevel()
    }}
  </span>
  <span
    *appCheckPermission="permissions.createApprovalRequest"
    class="bold-text"
  >
    {{ maturityLevel() }}->{{
      nextMaturityLevel() +
        " " +
        res("Ubt-MeasureDetail-Approval-Request-Request")
    }}
  </span>

  <form action="post" (submit)="submitAction($event)">
    <abc-form [formData]="formData">
      <dxi-item
        itemType="group"
        cssClass="flex-row"
        *appCheckPermission="permissions.changeHardenessDegree"
      >
        <dxi-item>{{
          res(
            "Ubt-MeasureDetail-Approval-Request-Target-Maturity-Level"
          )
        }}</dxi-item>
        <dxi-item>
          <abc-select-box
            #maturityLevelField
            class="drop-down-style"
            [stylingMode]="'outlined'"
            [width]="'70%'"
            [height]="'100%'"
            [(value)]="formData.maturityLevel"
            [dataSource]="maturityLevelList"
            [label]="res('Ubt-MeasureDetail-Maturity-Level')"
            [labelMode]="'floating'"
            displayExpr="name"
            valueExpr="value"
          >
            <dx-validator #maturityLevelValidator>
              <dxi-validation-rule
                type="custom"
                [validationCallback]="validateMaturityChange"
                [message]="
                  res(
                    'Ubt-MeasureDetail-Approval-Request-Select-Different-Maturity-Level'
                  )
                "
              >
              </dxi-validation-rule>
            </dx-validator>
          </abc-select-box>
        </dxi-item>
      </dxi-item>
      <dxi-item>
        <abc-text-area
          class="reponsive-comment-area"
          [stylingMode]="'outlined'"
          [width]="'100%'"
          [height]="150"
          [label]="res(
                    'Ubt-MeasureDetail-Approval-Request-Reason'
                  )"
          [labelMode]="'floating'"
          [(value)]="formData.reason"
        >
          <dx-validator #reasonValidator>
            <dxi-validation-rule
              type="required"
              [message]="res('Ubt-validator-RequiredField')"
            >
            </dxi-validation-rule>
          </dx-validator>
        </abc-text-area>
      </dxi-item>
      <dxi-item itemType="group" cssClass="form-buttons-container">
        <dxi-item itemType="group" cssClass="form-buttons-container">
          @if (!canWithdraw()) {
            <dxi-item
              itemType="button"
              cssClass="submit-button button-left"
              [buttonOptions]="submitButtonOptions"
            >
            </dxi-item>
          } @else {
            <dxi-item
              itemType="button"
              cssClass="reverse-colored-button button-left"
              [buttonOptions]="withdrawButtonOptions"
            >
            </dxi-item>
          }
          <dxi-item
            *appCheckPermission="[
              permissions.approveRequestStep1,
              permissions.approveRequestStep2,
            ]"
            itemType="button"
            cssClass="reverse-colored-button button-left"
            [buttonOptions]="withdrawButtonOptions"
          >
          </dxi-item>
        </dxi-item>
        <dxi-item
          itemType="button"
          cssClass="cancel-button button-right"
          [buttonOptions]="cancelButtonOptions"
        >
        </dxi-item>
      </dxi-item>
    </abc-form>
  </form>
}
<div class="vSpace"></div>
<span class="bold-text">{{
  res("Ubt-MeasureDetail-Approval-Request-Timeline")
}}</span>
<abc-scroll-view
  #timelineScrollView
  [height]="isTimeline() ? '100%' : '300px'"
  width="100%"
  direction="vertical"
  showScrollbar="always"
>
  <dx-stepper
    id="timelineStepper"
    [dataSource]="steps"
    [linear]="false"
    [elementAttr]="{ 'aria-labelledby': 'label-customStepShape' }"
    orientation="vertical"
    [hoverStateEnabled]="false"
    [activeStateEnabled]="false"
  >
    <div *dxTemplate="let data of 'item'; let i = index">
      <div class="dx-step-indicator">
        @if (data.Icon) {
          <i
            class="dx-icon step-icon"
            [ngClass]="['dx-icon-' + data.Icon, getStatus(data.Status) | lowercase]"
          ></i>
        } @else {
          <div [innerHTML]="submitIconSvg" class="step-icon submitted"></div>
        }
      </div>
      <div class="dx-step-caption">
        <div class="dx-step-label bold-text">
          {{
            formatAction(
              data.User,
              data.Role,
              data.Status
            )
          }}
        </div>
        <div class="dx-step-label date">
          {{ data.Date | date: "dd.MM.yyyy, HH:mm" }}
        </div>
        <div
          class="dx-step-label comment"
          [class.expanded]="expandedreasonIndex === i"
          (click)="expandReason(i)"
        >
          {{
            data.Reason
              | truncate: (expandedReasonIndex === i ? data.Reason.length : maxDisplayedChar)
          }}
        </div>
      </div>
    </div>
  </dx-stepper>
</abc-scroll-view>
</div>
@if (isLoading()) {
  <ubt-loader></ubt-loader>
}
